import React from 'react'
import PropTypes from 'prop-types'
import { getPages } from './utils'


const Pager = props => {
  const pages = getPages(props.current, props.total);
  const isPrevDisabled = props.current === 1;
  const isNextDisabled = props.current === props.total;

  const previous = (
    <li key="prev" className={`pagination__page pagination__page--prev ${isPrevDisabled ? 'pagination__page--disabled' : ''}`}>
      <button
        onClick={() => props.onPageChange(props.current - 1)}
        className="pagination__button"
        disabled={isPrevDisabled}
      >
        <svg className="pagination__arrow"><use xlinkHref="#pager-prev" /></svg>
        {props.labelPrev}
      </button>
    </li>
  );

  const next = (
    <li key="next" className={`pagination__page pagination__page--next ${isNextDisabled ? 'pagination__page--disabled' : ''}`}>
      <button
        onClick={() => props.onPageChange(props.current + 1)}
        className="pagination__button"
        disabled={isNextDisabled}
      >
        {props.labelNext}
        <svg className="pagination__arrow"><use xlinkHref="#pager-next" /></svg>
      </button>
    </li>
  )

  return (
    <ol className="pagination__pager">
      {previous}
      {pages.map(p => (
        <li key={`${p.page}-${p.isEllipses ? 'ellipses' : ''}`} className={`pagination__page ${p.isCurrent ? 'pagination__page--current' : ''}`}>
          <button onClick={() => props.onPageChange(p.page)} className="pagination__button">{p.isEllipses ? '...' : p.page}</button>
        </li>
      ))}
      {next}
    </ol>
  )
}

Pager.propTypes = {
  labelPrev: PropTypes.string,
  labelNext: PropTypes.string
}

Pager.defaultProps = {
  labelPrev: 'Prev',
  labelNext: 'Next'
}

export default Pager
